import { ItemView } from './common/CommonComponents';
import { useAuth } from '../utils/AuthContext.js';

const EmailView = () => {
  const { user } = useAuth();

  const items = [
    {
      field: 'email',
      value: user.email,
    },
  ];

  return <ItemView items={items} />;
};

export default EmailView;
